'use client'
import Image from 'next/image'

import { miscSocialMediaLinkClickEvent } from '@lib/analytics-events'

import styles from './social-links.module.scss'

import type { JSX } from 'react'

type SocialLinksProps = {
  theme?: 'light' | 'dark'
}

type SocialLinkProps = {
  href: string
  alt: string
  iconSize?: number
  // facebook.svg is the only non-square icon here (viewBox 320x512, ratio 0.625); minireset's
  // global `img { height: auto }` already renders it at that ratio, so reusing iconSize for height
  // never matched what was on screen. [S20-865]
  iconHeight?: number
  iconUrl: string
}

const websitesList = [
  { name: 'facebook', href: 'https://www.facebook.com/SONICJOBS/', alt: 'Facebook', iconSize: 15, iconHeight: 24 },
  { name: 'x', href: 'https://twitter.com/sonicjobsapp', alt: 'X' },
  { name: 'instagram', href: 'https://www.instagram.com/sonicjobs', alt: 'Instagram' },
  { name: 'youtube', href: 'https://www.youtube.com/channel/UCbqoQ80jaeoejeb9JIHZb6Q', alt: 'YouTube' },
  { name: 'linkedin', href: 'https://www.linkedin.com/company/sonicjobs/', alt: 'Linkedin' },
]

function SocialLink({ href, alt, iconSize = 47, iconHeight, iconUrl }: SocialLinkProps): JSX.Element {
  return (
    <a
      className={styles.link}
      href={href}
      target="_blank"
      rel="noreferrer"
      onClick={(): void => miscSocialMediaLinkClickEvent(alt)}
    >
      <Image src={iconUrl} alt={alt} width={iconSize} height={iconHeight ?? iconSize} className={styles.logo} />
    </a>
  )
}

export default function SocialLinks({ theme = 'light' }: SocialLinksProps): JSX.Element {
  return (
    <div className={`${styles['social-media']} ${styles[theme]}`}>
      {websitesList.map((website, i) => (
        <SocialLink
          href={website.href}
          iconSize={website.iconSize}
          iconHeight={website.iconHeight}
          key={i}
          iconUrl={`/images/social/${website.name}.svg`}
          alt={website.alt}
        />
      ))}
    </div>
  )
}
